// Update App.js with mobile support
import React, { useState } from "react";
import Sidebar from "./page/Navbar/Sidebar ";
import TopBar from "./page/Navbar/Topbar";
import "../src/App.css";
import AppRoutes from "./AppRoutes";
import { useLocation, useNavigate } from "react-router-dom";
import "../src/styles/sidebar.css";
import { useSelector } from "react-redux";

const App = () => {
  const [activeMenuItem, setActiveMenuItem] = useState("");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const location = useLocation();

  const { isAuthenticated } = useSelector((state) => state.auth);
  const hideLayoutRoutes = [
    "/admin/login",
    "/institutions/login",
    "/institutions/signup",
    "/privacy",
    "/terms",
  ];

  const isLandingPage = location.pathname === "/" && !isAuthenticated;
  const shouldHideLayout = hideLayoutRoutes.includes(location.pathname) || isLandingPage;

  const navigate = useNavigate();
  const handleMenuClick = (menuItem) => {
    setActiveMenuItem(menuItem.id);
    navigate(menuItem.path);
    setShowMobileMenu(false);
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  if (shouldHideLayout) {
    return (
      <div className="dashboard-app">
        <AppRoutes />
      </div>
    );
  }

  return (
    <div className="dashboard-app">
      <Sidebar
        activeMenuItem={activeMenuItem}
        onMenuClick={handleMenuClick}
        isCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
        className={showMobileMenu ? "open" : ""}
      />

      <div
        className={`overlay ${showMobileMenu ? "active" : ""}`}
        onClick={() => setShowMobileMenu(false)}
      ></div>

      <main
        className={`main-content ${isSidebarCollapsed ? "sidebar-collapsed" : ""}`}
      >
        <TopBar
          toggleSidebar={toggleSidebar}
          isSidebarCollapsed={isSidebarCollapsed}
          showMobileMenu={showMobileMenu}
          setShowMobileMenu={setShowMobileMenu}
        />

        <div
          className={`container-content ${isSidebarCollapsed ? "collapsed" : "expanded"}`}
        >
          <AppRoutes />
        </div>
      </main>
    </div>
  );
};

export default App;
